import { useState } from 'react';
import { fmtAmount, PartyAvatar } from '../lib/helpers';
import { AddPartyModal } from '../components/AddPartyModal';

export function PartiesPage({ parties, onAdd, onPartyClick, onDelete }) {
  const [showAdd, setShowAdd]   = useState(false);
  const [search, setSearch]     = useState('');
  const [filter, setFilter]     = useState('all'); // all | get | give | customer | supplier

  const filtered = parties.filter(p => {
    const matchSearch = p.name.toLowerCase().includes(search.toLowerCase()) ||
                        (p.phone || '').includes(search);
    const matchFilter = filter === 'all' ? true
      : filter === 'get'      ? p.balance > 0
      : filter === 'give'     ? p.balance < 0
      : filter === 'customer' ? p.type === 'customer'
      : filter === 'supplier' ? p.type === 'supplier'
      : true;
    return matchSearch && matchFilter;
  });

  const youWillGet  = parties.filter(p => p.balance > 0).reduce((s, p) => s + p.balance, 0);
  const youWillGive = parties.filter(p => p.balance < 0).reduce((s, p) => s + p.balance, 0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Summary strip */}
      <div className="balance-strip">
        <div className="bal-strip-item">
          <div className="bal-strip-label">You will Get</div>
          <div className="bal-strip-amount" style={{ color: 'var(--green-dark)' }}>{fmtAmount(youWillGet)}</div>
        </div>
        <div className="bal-strip-item">
          <div className="bal-strip-label">You will Give</div>
          <div className="bal-strip-amount" style={{ color: 'var(--red-dark)' }}>{fmtAmount(Math.abs(youWillGive))}</div>
        </div>
        <div className="bal-strip-item">
          <div className="bal-strip-label">Total Parties</div>
          <div className="bal-strip-amount">{parties.length}</div>
        </div>
      </div>

      {/* Search */}
      <div className="search-bar">
        <span>🔍</span>
        <input className="search-input" placeholder="Search parties by name or phone..."
          value={search} onChange={e => setSearch(e.target.value)} />
        <button className="btn btn-blue btn-sm" onClick={() => setShowAdd(true)}>➕ Add</button>
      </div>

      {/* Chips */}
      <div className="chip-bar">
        {[
          { id: 'all',      label: 'All' },
          { id: 'get',      label: '📥 Will Get' },
          { id: 'give',     label: '📤 Will Give' },
          { id: 'customer', label: '🧑 Customers' },
          { id: 'supplier', label: '🏪 Suppliers' },
        ].map(c => (
          <button key={c.id} className={`chip${filter === c.id ? ' active' : ''}`}
            onClick={() => setFilter(c.id)}>
            {c.label}
          </button>
        ))}
      </div>

      {/* List */}
      <div className="content">
        <div style={{ padding: '12px 16px' }}>
          {filtered.length === 0 ? (
            <div className="empty">
              <div className="empty-icon">👥</div>
              <div>No parties found</div>
              <button className="btn btn-blue" style={{ margin: '12px auto', display: 'flex' }}
                onClick={() => setShowAdd(true)}>➕ Add Party</button>
            </div>
          ) : (
            <div className="party-list">
              {filtered.map(p => {
                const willGet  = p.balance > 0;
                const willGive = p.balance < 0;
                return (
                  <div key={p.id} className="party-row" onClick={() => onPartyClick(p)}>
                    <PartyAvatar name={p.name} />
                    <div className="party-info">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div className="party-name">{p.name}</div>
                        <span className={`party-type-badge badge-${p.type}`}>
                          {p.type === 'customer' ? 'Customer' : 'Supplier'}
                        </span>
                      </div>
                      <div className="party-phone">{p.phone || 'No phone'}</div>
                    </div>
                    <div className="party-balance">
                      {Math.abs(p.balance) < 0.01 ? (
                        <>
                          <div className="party-bal-amount" style={{ color: 'var(--text-faint)' }}>₹0</div>
                          <div className="party-bal-label" style={{ color: 'var(--text-faint)' }}>Settled</div>
                        </>
                      ) : willGet ? (
                        <>
                          <div className="party-bal-amount text-green">{fmtAmount(p.balance)}</div>
                          <div className="party-bal-label" style={{ color: 'var(--green-dark)' }}>Will Get</div>
                        </>
                      ) : (
                        <>
                          <div className="party-bal-amount text-red">{fmtAmount(p.balance)}</div>
                          <div className="party-bal-label" style={{ color: 'var(--red-dark)' }}>Will Give</div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {showAdd && <AddPartyModal onSave={onAdd} onClose={() => setShowAdd(false)} />}
    </div>
  );
}
